import React, { InputHTMLAttributes } from 'react';
import { FieldProps } from 'formik';
import styled from 'styled-components';
import ReactCodeMirror from 'react-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/markdown/markdown';

// utils
import { unescapeText } from 'utils/helpers';

const CodeMirror = styled(ReactCodeMirror)`
  &.ReactCodeMirror {
    display: inline-grid;
    width: 100%;
    border: 1px solid #ddd;
    cursor: text;
    transition: all 400ms ease;

    .CodeMirror .CodeMirror-scroll .CodeMirror-gutters {
      z-index: 0;
    }
  }

  &.CodeMirror-selected {
    opacity: 0.5;
  }
`;

interface OwnProps {
  options?: {
    lineNumbers?: boolean;
    readOnly: boolean;
  };
}

type Props = InputHTMLAttributes<HTMLInputElement> & FieldProps & OwnProps;

const CodeEditor = ({ field: { name, value }, form: { setFieldValue }, options, disabled }: Props) => {
  const onChange = (newValue: string) => {
    setFieldValue(name, newValue);
  };

  return (
    <CodeMirror
      value={unescapeText(value)}
      onChange={onChange}
      options={{ lineNumbers: true, readOnly: disabled, lineWrapping: true }}
    />
  );
};

export default CodeEditor;
